import axios from "axios";
import {alarmUrl} from "./network";

export const getAiProfitAlarmData = ({limit, page}) => {
    const headers = {
        'Content-Type': 'application/json',
    }
    // const cacheBuster = `v=${Date.now()}`
    return axios.get(`${alarmUrl}/alarms/ai-profit-alarms?limit=${limit}&page=${page}`, {headers})
        .then((res) => res)
}

export const getAiSpottersAlarmData = ({limit, page}) => {
    const headers = {
        'Content-Type': 'application/json',
    }
    // const cacheBuster = `v=${Date.now()}`
    return axios.get(`${alarmUrl}/alarms/ai-spotters?limit=${limit}&page=${page}`, {headers})
        .then((res) => res)
}

